module.exports = __webpack_public_path__ + "img/气泡_2@2x.e66555af.png";